import { Root } from "@radix-ui/react-label"
import clsx from "clsx"

import { TruncatableText } from "@particles"

import { Hint, HintTrigger } from "@atoms"

import styles from "./Label.module.scss"
import { LabelProps } from "./Label.types"

export default function Label(props: LabelProps) {
    const {
        label,
        variant = "default",
        truncate = false,
        tooltipOnTruncate = false,
        hint,
        condition,
        htmlFor,
        className,

        isControlLabel = true,
        isDisabled = false,

        ...rest
    } = props

    const Component = isControlLabel ? Root : "span"

    // The root is a span in both modes so Label stays valid inside a <button> or <label>.
    return (
        <span className={clsx(styles.base, styles[`${variant}Variant`], className)}>
            <Component
                className={clsx(styles.label, {
                    [styles.clickable]: htmlFor !== undefined,
                    [styles.disabled]: isDisabled,
                })}
                htmlFor={htmlFor}
                {...rest}
            >
                <span className={styles.text}>
                    {truncate ? (
                        <TruncatableText text={label} tooltipOnTruncate={tooltipOnTruncate} tooltipPlacement="top" />
                    ) : (
                        label
                    )}
                </span>
                {condition && <span className={styles.condition}>({condition})</span>}
            </Component>
            {hint && (
                <span className={styles.hintTrigger}>
                    <Hint {...hint}>
                        <HintTrigger />
                    </Hint>
                </span>
            )}
        </span>
    )
}
